import amountTypeOptions from "@coworker/enums/amountTypes";
import type { SelectedItems } from "../context/selectedItemsReducer";
import { QUANTITY_MAX_THRESHOLD_PIECES } from "@coworker/apprestructured/src/shared/constants/addon";

export const addonTemplate = {
  created_at: "2025-03-18T07:30:29.706Z",
  task_type: "ADDON",
  creator_id: "",
  last_editor_id: "",
  store_id: "",
  archived_at: 0,
  refilled_by_me: false,
  refill_type: "REGULAR",
  priority_flag: false,
  product_article_id: "need to be filled",
  product_article_type: "ART",
  supplier_number: "",
  scanned_supplier_number: "",
  assigned_team_id: "",
  assigned_user_id: "",
  item_name: "need to be filled",
  panumber: "need to be filled",
  item_type: "",
  item_color: "",
  item: {
    measurements: "",
  },
  product_article_price: 0,
  product_article_currency: "need to be filled",
  product_article_price_missing: false,
  pickup_location: "need to be filled",
  pickup_location_grid_code: "need to be filled",
  pickup_location_department: "need to be filled",
  pickup_location_custom: "",
  location: "need to be filled",
  location_grid_code: "need to be filled",
  location_department: "need to be filled",
  location_custom: "",
  home_location: "need to be filled",
  primary_location: "need to be filled",
  requested_quantity: 0,
  actual_requested_quantity: 0,
  requested_type: amountTypeOptions.PIECES,
  refilled_quantity: null,
  pick_quantity: null,
  team_assignments_refilling: {},
  team_assignments_picking: {},
  state: "need to be filled",
  activity_type: "need to be filled",
  activity_type_last: "need to be filled",
  images: [],
};

const getActityType = (state: string) => {
  switch (state) {
    case "COMPLETED":
      return "CREATE_AND_COMPLETE";
    case "ASSIGNED":
      return "CREATE_AND_ASSIGN_TO_USER";
    case "UNASSIGNED":
      return "CREATE_AND_ASSIGN_TO_TEAM";
    default:
      return "";
  }
};

export const formatAddonsToCreate = (
  selectedArticles: SelectedItems,
  template: typeof addonTemplate
) => {
  return Object.values(selectedArticles).map((article) => ({
    ...template,
    ...article,
    product_article_id: (article.articleNumber ?? "").replace(/\./g, ""),
    pickup_location_grid_code: article.pickupLocation,
    pickup_location: article.pickupLocation,
    pickup_location_department: article.pickupLocation,
    location_grid_code: article.refillLocation,
    location: article.refillLocation,
    location_department: article.refillLocation,
    item_name: article.name,
    requested_quantity: article.selectedPieces,
    actual_requested_quantity: article.selectedPieces,
    activity_type: getActityType(template.state),
    activity_type_last: getActityType(template.state),
    ...(template.state === "COMPLETED" && {
      finished_at: new Date().toISOString(),
      refilled_quantity: article.selectedPieces,
      actual_refilled_quantity: article.selectedPieces,
      refilled_type: amountTypeOptions.PIECES,
    }),
    activity_type_last_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    last_assigned_at: new Date().toISOString(),
  }));
};

export const piecesValidation = (
  pieces: string,
  maxQuantity: number,
  availableStock?: number
) => {
  const parsedPieces = pieces ? parseInt(pieces) : 0;
  if (
    maxQuantity &&
    parsedPieces > maxQuantity &&
    parsedPieces <= QUANTITY_MAX_THRESHOLD_PIECES
  ) {
    return {
      hasError: true,
      message: "exceedingMaxPiecesString",
    };
  } else if (parsedPieces > QUANTITY_MAX_THRESHOLD_PIECES) {
    return {
      hasError: true,
      message: "exceedingMaxThresholdString",
    };
  }
  if (parsedPieces < 1 || !pieces) {
    return {
      hasError: true,
      message: "minimumOnePieceString",
    };
  }
  if (availableStock && parsedPieces > availableStock) {
    return {
      hasWarning: true,
      message: "exceedingAvailableStockString",
    };
  }
  return {
    hasError: false,
    message: "",
  };
};

type GetStateAndAssignmentProps = {
  markAsCompleted: boolean;
  assignee: {
    gid: string;
    uid: string;
  };
  userId: string;
  teamId: string;
};

export const getStateAndAssignment = ({
  markAsCompleted,
  assignee,
  teamId,
  userId,
}: GetStateAndAssignmentProps) => {
  if (markAsCompleted) {
    return {
      state: "COMPLETED",
      assigned_team_id: assignee.uid && assignee.gid ? assignee.gid : teamId,
      assigned_user_id: assignee.uid || userId,
      task_finisher_id: assignee.uid || userId,
    };
  }
  return {
    assigned_team_id: assignee.gid || "",
    assigned_user_id: assignee.uid || "",
    state: assignee.uid ? "ASSIGNED" : "UNASSIGNED",
  };
};
